
class OrderSummary {
    total = 0;
    firstTermDiscount = 0;
    firstTermBasePrice = 0;
    prorateDiscount = 0;
    recurringPrice = 0;
    firstTermExtraSeatsPrice = 0;
    extraSeatsRecurringPrice = 0;
    currentExtraSeatsPrice = 0;
    prorateAmount = 0;


    constructor(orderSummary) {
        if (orderSummary && orderSummary.hasOwnProperty('total')) {
            this.total = orderSummary.total;
            /* istanbul ignore else */
            if(orderSummary.hasOwnProperty('newSubscription')) {
                this.firstTermDiscount = orderSummary.newSubscription.firstTermDiscount;
                this.firstTermBasePrice = orderSummary.newSubscription.firstTermBasePrice;
                this.prorateDiscount = orderSummary.newSubscription.prorateDiscount;
                this.recurringPrice = orderSummary.newSubscription.recurringPrice;
                this.firstTermExtraSeatsPrice = orderSummary.newSubscription.firstTermExtraSeatsPrice;
                this.extraSeatsRecurringPrice = orderSummary.newSubscription.extraSeatsRecurringPrice;
            }

            if(orderSummary.hasOwnProperty('proration')) {
                this.prorateAmount = orderSummary.proration.prorateAmount;
                if (orderSummary.proration.hasOwnProperty('currentExtraSeatsPrice')) {
                    this.currentExtraSeatsPrice = orderSummary.proration.currentExtraSeatsPrice;
                }
            }
        }
    }

    setTotal = (total) => {
        this.total = total;
    };

    getTotal = () => {
        return this.total;
    };

    setFirstTermDiscount = (firstTermDiscount) => {
        this.firstTermDiscount = firstTermDiscount;
    };

    getFirstTermDiscount = () => {
        return this.firstTermDiscount;
    };

    setFirstTermBasePrice = (firstTermBasePrice) => {
        this.firstTermBasePrice = firstTermBasePrice;
    };

    getFirstTermBasePrice = () => {
        return this.firstTermBasePrice;
    };

    setProrateDiscount = (prorateDiscount) => {
        this.prorateDiscount = prorateDiscount;
    };

    getProrateDiscount = () => {
        return this.prorateDiscount;
    };

    setRecurringPrice = (recurringPrice) => {
        this.recurringPrice = recurringPrice;
    };

    getRecurringPrice = () => {
        return this.recurringPrice;
    };

    setFirstTermExtraSeatsPrice = (firstTermExtraSeatsPrice) => {
        this.firstTermExtraSeatsPrice = firstTermExtraSeatsPrice;
    };

    getFirstTermExtraSeatsPrice = () => {
        return this.firstTermExtraSeatsPrice;
    };

    setExtraSeatsRecurringPrice = (extraSeatsRecurringPrice) => {
        this.extraSeatsRecurringPrice = extraSeatsRecurringPrice;
    };

    getExtraSeatsRecurringPrice = () => {
        return this.extraSeatsRecurringPrice;
    };

    getCurrentExtraSeatsPrice = () => {
        return this.currentExtraSeatsPrice;
    }

    getProrateAmount = () => {
        return this.prorateAmount;
    }
}

export default OrderSummary